/**
 * Session-results import parser — the Record app's column-mapper targets, and
 * the pure core it shares with the public API
 * (`supabase/functions/_shared/sessionImportCore.ts`, POST
 * /v1/import/session-results). One parser: a file imported here and the same
 * rows sent to the API become the same session.
 */

import type { AppField } from '@/components/prioritization/import-export/ColumnMapper';

export * from '../../../supabase/functions/_shared/sessionImportCore.ts';

/** The mapping targets offered in the column mapper (both shapes). */
export const SESSION_IMPORT_FIELDS: AppField[] = [
  { key: 'title', label: 'Item title', required: true, type: 'string', description: 'What was prioritized — one option per distinct title' },
  { key: 'rank', label: 'Rank', required: false, type: 'number', description: '1 = top. Omit to rank by score (or file order)' },
  { key: 'score', label: 'Score', required: false, type: 'number', description: 'Any numeric scale. In full results: one score per row' },
  { key: 'participant', label: 'Participant', required: false, type: 'string', description: 'Who gave this score (full results shape)' },
  { key: 'participant_email', label: 'Participant email', required: false, type: 'string', description: 'Links the participant to the workspace member with exactly this email' },
  { key: 'criterion', label: 'Criterion', required: false, type: 'string', description: 'What the score measures (full results shape)' },
  { key: 'weight', label: 'Criterion weight', required: false, type: 'number', description: 'Relative weight of this row’s criterion (default 1)' },
  { key: 'external_id', label: 'External ID', required: false, type: 'string', description: 'Stable ID from the source system — used to match existing items' },
  { key: 'item_id', label: 'Platform item ID', required: false, type: 'string', description: 'Priorities.ai item UUID, when you have it' },
  { key: 'description', label: 'Description', required: false, type: 'string', description: 'Used only when a row creates a new item' },
];
